import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import getLocale from 'helpers/getLocale';
import Serialize from './Serialize';
import Link from './Link';
import Media from './Media';

const TypographyStyled = styled(Typography)(({ theme }) => ({
  marginBottom: 20,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: theme.palette.textPrimary.main,
  [theme.breakpoints.down('lg')]: {
    display: 'block'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '41.4px',
    marginBottom: 20
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '36.4px',
    marginBottom: 25
  }
}));

const List = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  padding: 0,
  '& li': {
    marginBottom: 10,
    '& a': {
      color: theme.palette.textPrimary.main,
      fontSize: 18,
      lineHeight: '20px',
      fontFamily: 'Rubik-Regular',
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  }
}));

const MainWrapper = styled('div')(({ theme }) => ({
  '& a': {
    background: theme.palette.primary.main,
    color: theme.palette.textPrimary.main,
    padding: '1px',
    textDecoration: 'none',
    borderBottom: 'solid theme.palette.black.main 2px',
    fontFamily: 'Rubik-Regular'
  }
}));

const RenderPageSchema = ({ schema = {}, hideTitle = false, component, sx }) => {
  const lang = getLocale().toLowerCase();

  return (
    <>
      {!hideTitle && (
        <TypographyStyled variant="h1">{schema?.title?.[lang] || schema?.title}</TypographyStyled>
      )}

      {(schema?.layout || []).map((item) => {
        if (!item) return null;

        const { richText, richtext, content, media, links, blockType, text, id } = item;

        const source = richText || richtext || content || item;

        return (
          <MainWrapper key={id}>
            <Serialize content={source?.[lang] || source} component={component} sx={sx} />

            {blockType === 'disclaimer' ? <TypographyStyled>{text}</TypographyStyled> : null}

            {Array.isArray(links) && (
              <List>
                {links.map(({ link }, i) => {
                  return (
                    <li key={i}>
                      <Link {...link} />
                    </li>
                  );
                })}
              </List>
            )}

            {typeof media === 'object' ? <Media resource={media} /> : null}
          </MainWrapper>
        );
      })}
    </>
  );
};

export default RenderPageSchema;
